import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { config } from '../config/config';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  };
  config: any = config;

  registerSubmittedList: any[] = [];
  constructor(private http: HttpClient) { }

  logout(user: any) {
    let URL = environment.URL + this.config.URL.logoutURL;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, user, this.options);
  }

  getUserDetails(userId: number) {
    let URL = environment.URL + this.config.URL.getUserDetails + '/' + userId;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
    return this.http.get(URL, this.options);
  }

  getUserDetailsByLoginId(userId: string) {
    let URL = environment.URL + this.config.URL.getUserMenusByLoginId + '/' + userId;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
    return this.http.get(URL, this.options);
  }

  fetchRegisterRequests(requestObject: any) {
    let URL = environment.URL + this.config.URL.fetchRegisterRequests;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
    return this.http.post(URL, requestObject, this.options);
  }

  getDynamicFieldList() {
    let URL = environment.URL + this.config.URL.getDynamicFieldList;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
    return this.http.get(URL, this.options);
  }

  saveOrSubmitData(requestObject: any, registerToken: any) {
    let URL = environment.URL + this.config.URL.saveOrSubmitData;
    this.options.headers = this.options.headers.set('Authorization', registerToken)
    return this.http.post(URL, requestObject, this.options);
  }

  generateOTP(requestObject) {
    let URL = environment.URL + this.config.URL.generateOTPReg;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
    return this.http.post(URL, requestObject, this.options);
  }

  validateOTP(requestObject) {
    let URL = environment.URL + this.config.URL.validateOTPReg;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
    return this.http.post(URL, requestObject, this.options);
  }

  getUserMenusDerivative(userId, derivative) {
    let URL = environment.URL + this.config.URL.getUserMenusDerivative + '/' + userId + '/' + derivative;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
    return this.http.get(URL, this.options);
  }

  uploadRegisterFile(registerToken, file, fileType, regId, fileID) {
    let URL = environment.URL + this.config.URL.uploadRegisterFile;
    let fileOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + registerToken
      })
    };
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('fileType', fileType);
    formData.append('regID', regId);
    formData.append('fileID', fileID);
    formData.append('refID', registerToken);
    return this.http.post(URL, formData, fileOptions);
  }

  addAuthorisedPerson(registerSubmittedList: any[]) {
    this.registerSubmittedList = registerSubmittedList;
  }

  getRegFormByRegID(id: String) {
    return this.registerSubmittedList.find(data => data.regID == id);
  }

  makerCheckerAction(requestObject: any) {
    let URL = environment.URL + this.config.URL.makerCheckerAction;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
    return this.http.post(URL, requestObject, this.options);
  }

  saveUserMenuMappings(request: any) {
    let URL = environment.URL + this.config.URL.saveUserMenuMappings;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
    return this.http.post(URL, request, this.options);
  }

  downloadRegisterFile(systemFileName) {
    let URL = environment.URL + this.config.URL.downloadRegisterFile + '?systemFileName=' + systemFileName;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, {}, this.options);
  }

  getUserList() {
    let URL = environment.URL + this.config.URL.userListURL;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  addUser(user: any) {
    let URL = environment.URL + this.config.URL.addUserURL;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL, user, this.options);
  }

  updateUser(action: string, user: any) {
    let URL = environment.URL + this.config.URL.updateUserURL + '/' + action;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
    return this.http.post(URL, user, this.options);
  }

  getAutoPopulatedUserValues() {
    let URL = environment.URL + this.config.URL.getAutoPopulatedUserValues;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  fetchRegisterMaster(requestObject) {
    let URL = environment.URL + this.config.URL.fetchRegisterMaster;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
    return this.http.post(URL, requestObject, this.options);
  }

  getMemberMenus() {
    let URL = environment.URL + this.config.URL.getMemberMenus;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.get(URL, this.options);
  }

  saveMenuList(requestObject) {
    let URL = environment.URL + this.config.URL.saveMenuList;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
    return this.http.post(URL, requestObject, this.options);
  }

  checkLoginId(requestObject) {
    let URL = environment.URL + this.config.URL.checkLoginId;
    this.options.headers = this.options.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
    return this.http.post(URL,requestObject, this.options);
  }

}
